import comp from "./IBSkills";
export default comp;
